module.exports = __webpack_public_path__ + "img/main-bg.06ea25fd.svg";